// src/pages/Contact.js
import { useState } from 'react';
import { Link } from 'react-router-dom';

// ← Replace with your real Calendly link
const CALENDLY_URL = 'https://calendly.com/your-link-here';

const labelStyle = {
  display: 'block', fontSize: '0.68rem', fontWeight: 700,
  letterSpacing: '0.08em', textTransform: 'uppercase',
  color: 'rgba(255,255,255,0.4)', marginBottom: 7,
};

const inputStyle = {
  width: '100%', padding: '11px 14px',
  background: 'rgba(255,255,255,0.05)',
  border: '1.5px solid rgba(255,255,255,0.1)',
  borderRadius: 9, outline: 'none',
  fontFamily: 'var(--font-body)', fontSize: '0.875rem',
  color: 'white',
};

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', role: '', message: '' });
  const [sent, setSent] = useState(false);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: wire to Formspree, EmailJS, or a Firebase Cloud Function
    setSent(true);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy-deep)', fontFamily: 'var(--font-body)' }}>

      {/* Ambient background */}
      <div style={{
        position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0,
        background: `
          radial-gradient(ellipse 60% 50% at 80% 10%, rgba(203,164,58,0.08) 0%, transparent 60%),
          radial-gradient(ellipse 40% 60% at 10% 80%, rgba(95,121,66,0.07) 0%, transparent 60%)
        `,
      }} />

      {/* Nav */}
      <nav style={{
        position: 'relative', zIndex: 10,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '24px 52px',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}>
        <Link to="/dashboard">
          <img src="/logo-white.png" alt="Meeting.Training" style={{ height: 32 }} />
        </Link>
        <div style={{ display: 'flex', gap: 28, alignItems: 'center' }}>
          <Link to="/pricing" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem', textDecoration: 'none', fontWeight: 500 }}>Pricing</Link>
          <Link to="/dashboard" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem', textDecoration: 'none', fontWeight: 500 }}>Dashboard</Link>
        </div>
      </nav>

      {/* Hero */}
      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1100, margin: '0 auto', padding: '72px 52px 56px', textAlign: 'center' }}>
        <div style={{
          display: 'inline-block', fontSize: '0.65rem', letterSpacing: '0.22em',
          textTransform: 'uppercase', color: 'var(--gold)', fontWeight: 700,
          marginBottom: 20, padding: '5px 16px', borderRadius: 100,
          border: '1px solid rgba(203,164,58,0.3)', background: 'rgba(203,164,58,0.07)',
        }}>
          Let's talk
        </div>
        <h1 style={{
          fontFamily: 'var(--font-display)', fontSize: 'clamp(2rem, 5vw, 3.4rem)',
          color: 'white', fontWeight: 400, lineHeight: 1.18, marginBottom: 18,
        }}>
          Every great team starts<br />
          <em style={{ color: 'var(--gold-light)' }}>with an honest conversation.</em>
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.42)', fontSize: '1rem', lineHeight: 1.8, maxWidth: 500, margin: '0 auto' }}>
          Whether you want to book a call, ask a question, or explore what a consultant engagement looks like — we're here.
        </p>
      </div>

      {/* Two-column layout */}
      <div style={{
        position: 'relative', zIndex: 1, maxWidth: 1100, margin: '0 auto',
        padding: '0 52px 100px',
        display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 28, alignItems: 'start',
      }}>

        {/* LEFT — Book a call */}
        <div style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 20, overflow: 'hidden',
        }}>
          <div style={{ padding: '32px 36px 24px' }}>
            <div style={{
              fontSize: '0.65rem', letterSpacing: '0.16em', textTransform: 'uppercase',
              color: 'var(--gold)', fontWeight: 700, marginBottom: 10,
            }}>
              Fastest path forward
            </div>
            <h2 style={{
              fontFamily: 'var(--font-display)', fontSize: '1.55rem', fontWeight: 600,
              color: 'white', marginBottom: 10, lineHeight: 1.28,
            }}>
              Book a 20-minute call
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.42)', fontSize: '0.875rem', lineHeight: 1.75, marginBottom: 24 }}>
              Talk with a consultant. We'll listen to where your team is, show you what the platform can do, and give you an honest recommendation.
            </p>

            {/*
              CALENDLY EMBED — replace placeholder below with:
              <iframe
                src={`${CALENDLY_URL}?embed_type=Inline&hide_landing_page_details=1&hide_gdpr_banner=1`}
                width="100%" height="480" frameBorder="0" title="Book a call"
              />
            */}
            <div style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px dashed rgba(255,255,255,0.12)',
              borderRadius: 14, minHeight: 340,
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center', gap: 14, padding: 32,
              textAlign: 'center',
            }}>
              <div style={{
                width: 54, height: 54, borderRadius: 14,
                background: 'rgba(203,164,58,0.1)', border: '1px solid rgba(203,164,58,0.2)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem',
              }}>
                📅
              </div>
              <div>
                <div style={{ color: 'white', fontWeight: 600, fontSize: '0.95rem', marginBottom: 6 }}>
                  Calendly embed
                </div>
                <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.8rem', marginBottom: 22, lineHeight: 1.6 }}>
                  Set <code style={{ color: 'var(--gold)', background: 'rgba(203,164,58,0.1)', padding: '1px 6px', borderRadius: 4 }}>CALENDLY_URL</code><br />
                  at the top of Contact.js
                </div>
                <a
                  href={CALENDLY_URL} target="_blank" rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 8,
                    background: 'var(--gold)', color: 'var(--navy-deep)',
                    fontFamily: 'var(--font-body)', fontWeight: 700,
                    fontSize: '0.875rem', padding: '11px 24px',
                    borderRadius: 9, textDecoration: 'none',
                  }}
                >
                  Open booking page →
                </a>
              </div>
            </div>
          </div>

          {/* Trust row */}
          <div style={{
            padding: '16px 36px', borderTop: '1px solid rgba(255,255,255,0.06)',
            display: 'flex', gap: 24, flexWrap: 'wrap',
          }}>
            {[
              { icon: '⏱', text: '20 min · no pressure' },
              { icon: '🎯', text: 'Tailored advice' },
              { icon: '🔒', text: 'Confidential' },
            ].map(({ icon, text }) => (
              <div key={text} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                <span style={{ fontSize: '0.85rem' }}>{icon}</span>
                <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.32)', fontWeight: 500 }}>{text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT — Send a message */}
        <div>
          <div style={{
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 20, padding: '32px 36px',
          }}>
            <div style={{
              fontSize: '0.65rem', letterSpacing: '0.16em', textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.32)', fontWeight: 700, marginBottom: 10,
            }}>
              Prefer to write?
            </div>
            <h2 style={{
              fontFamily: 'var(--font-display)', fontSize: '1.55rem', fontWeight: 600,
              color: 'white', marginBottom: 10, lineHeight: 1.28,
            }}>
              Send us a message
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.38)', fontSize: '0.875rem', lineHeight: 1.7, marginBottom: 28 }}>
              We typically reply within one business day.
            </p>

            {sent ? (
              <div style={{ textAlign: 'center', padding: '48px 20px' }}>
                <div style={{
                  width: 56, height: 56, borderRadius: '50%',
                  background: 'rgba(95,121,66,0.18)', border: '1px solid rgba(95,121,66,0.3)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.4rem', margin: '0 auto 20px',
                }}>✓</div>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.4rem', color: 'white', marginBottom: 8 }}>
                  Message received
                </div>
                <div style={{ color: 'rgba(255,255,255,0.38)', fontSize: '0.875rem' }}>
                  We'll be in touch soon.
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div>
                    <label style={labelStyle}>Name</label>
                    <input type="text" required placeholder="Jane Smith"
                      value={form.name} onChange={e => set('name', e.target.value)} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Email</label>
                    <input type="email" required placeholder="jane@company.com"
                      value={form.email} onChange={e => set('email', e.target.value)} style={inputStyle} />
                  </div>
                </div>
                <div>
                  <label style={labelStyle}>I am a...</label>
                  <select value={form.role} onChange={e => set('role', e.target.value)} style={inputStyle}>
                    <option value="">Select one</option>
                    <option value="leader">Team Leader</option>
                    <option value="consultant">Consultant / Facilitator</option>
                    <option value="individual">Individual exploring the platform</option>
                    <option value="other">Something else</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Message</label>
                  <textarea required rows={5}
                    placeholder="Tell us about your team, what you're hoping to learn, or any questions you have..."
                    value={form.message} onChange={e => set('message', e.target.value)}
                    style={{ ...inputStyle, resize: 'vertical' }} />
                </div>
                <button type="submit" style={{
                  width: '100%', padding: '13px 22px',
                  background: 'rgba(255,255,255,0.07)',
                  border: '1.5px solid rgba(255,255,255,0.14)',
                  borderRadius: 10, color: 'white',
                  fontFamily: 'var(--font-body)', fontSize: '0.875rem', fontWeight: 600,
                  cursor: 'pointer', letterSpacing: '0.03em',
                }}>
                  Send message →
                </button>
              </form>
            )}
          </div>

          {/* Direct email */}
          <div style={{
            marginTop: 16, padding: '18px 22px',
            background: 'rgba(255,255,255,0.02)',
            border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: 14, display: 'flex', alignItems: 'center', gap: 14,
          }}>
            <div style={{
              width: 38, height: 38, borderRadius: 9, flexShrink: 0,
              background: 'rgba(95,121,66,0.12)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem',
            }}>✉</div>
            <div>
              <div style={{ fontSize: '0.68rem', color: 'rgba(255,255,255,0.28)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 3 }}>
                Email us directly
              </div>
              <a href="mailto:hello@meeting.training" style={{ color: 'var(--gold-light)', fontSize: '0.875rem', fontWeight: 600, textDecoration: 'none' }}>
                hello@meeting.training
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
